module.exports = __webpack_public_path__ + "assets/table_report_menu_icon-a0b669.svg";